import { Utils } from 'common';

const { Session } = Utils;

/**
 * public enum CustType : byte
    {
        Undefined = 0,
        Individual = 1,
        HomeBased = 2,
        OfficeBased = 3,
        HomeOffice = 4,
        PersonalUse = 6,
        BusinessUseMailing = 7,
        BusinessUseShipping = 8,
        BusinessUseMailingAndShipping = 9,
        NotEntered = 10,
        BusinessUseMultilocationEnterprise = 11
    }
 */

/**
 * Determines the user type for displaying appropriate content
 * @returns {string} 'consumer' or 'business'
 */

export const getUserType = () => {
	try {
		const custType = Session?.getInternalAccountInfo()?.CustType;
		const personalCustTypes = [0, 1, 6, 10];
		return personalCustTypes.includes(custType) ? 'consumer' : 'business';
	} catch (e) {
		return 'unknown';
	}
};
